import styled, { css } from 'styled-components';

export const Container = styled.div`
  height: 50px;
  background-color: ${({ theme }) => theme.colors.lightBlue};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Item = styled.div<{ selected?: boolean }>`
  padding: 0 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 50px;
  margin: 0;
  color: ${({ theme }) => theme.colors.white};
  font-size: 14px;
  font-weight: bold;
  transition: background-color 0.1s;

  ${({ theme, selected }) =>
    selected &&
    css`
      background-color: ${theme.colors.darkBlue};
    `}

  &:hover {
    background-color: ${({ theme, selected }) =>
      !selected ? theme.colors.midBlue : null};
  }
`;

export const Badge = styled.span`
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.darkBlue};
  margin-left: 16px;
  border-radius: 8px;
  padding: 3px 6px;
  font-size: 9px;
`;
